import { captureErrorAsync } from './utils/capture-error-async';
import { FeatureLogger } from './utils/feature-logger';

const logger = new FeatureLogger('wrap-install');

function isPromise<T, S>(obj: Promise<T> | S): obj is Promise<T> {
  if (obj == null) {
    return false;
  }

  return Boolean(
    (typeof obj === 'object' || typeof obj === 'function') &&
      typeof (obj as any)['then'] === 'function' &&
      typeof (obj as any)['catch'] === 'function'
  );
}

function handleError(featureName: string, e: unknown) {
  logger.error('Error when installing feature', featureName, e);
  captureErrorAsync(e as Error);
}

export function wrapInstall(
  featureName: string,
  install: (...args: unknown[]) => unknown
): typeof install {
  return (...args: unknown[]) => {
    try {
      logger.debug('Installing feature', featureName);

      const ret = install(...args);

      if (isPromise(ret)) {
        ret.catch((e: unknown) => handleError(featureName, e as Error));
      }

      return ret;
    } catch (e) {
      handleError(featureName, e);
      return undefined;
    }
  };
}
